import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontRightHeadlightProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function FrontRightHeadlight(props: FrontRightHeadlightProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Front Right Headlight"
      width={85}
      height={82}
      viewBox="0 0 85 82"
      position={{top: 24, left: 37}}
    >
      <path
        d="M61.8888 1.31834C29.6613 17.1625 1.68978 70.0403 1.68978 70.0403C-0.316853 74.0242 2.6931 80 2.6931 80C24.0097 50.9205 69.6613 11.5506 83.9617 8.29014C84.965 7.29417 65.9404 -0.673592 61.8888 1.31834Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M61.8888 1.31834C29.6613 17.1625 1.68978 70.0403 1.68978 70.0403C-0.316853 74.0242 2.6931 80 2.6931 80C24.0097 50.9205 69.6613 11.5506 83.9617 8.29014C84.965 7.29417 65.9404 -0.673592 61.8888 1.31834Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
